import React from "react";
import CrudManager from "./CrudManager";

const CATEGORIES = [
    { value: "hotel", label: "Hotel" },
    { value: "camping", label: "Camping" },
    { value: "hostal", label: "Hostal" },
    { value: "apartamento", label: "Apartamento" },
    { value: "otro", label: "Otro" },
];

export default function DirectoryManager() {
    return (
        <CrudManager
            testId="admin-directory"
            resource="/admin/directory"
            title="Directorio de socios"
            idField="id"
            columns={[
                { key: "name", label: "Nombre" },
                { key: "category", label: "Categoría" },
                { key: "location", label: "Ubicación" },
                { key: "featured", label: "Destacado" },
            ]}
            fields={[
                { name: "name", label: "Nombre", required: true },
                { name: "category", label: "Categoría", type: "select", options: CATEGORIES, required: true },
                { name: "description", label: "Descripción", type: "textarea", rows: 3 },
                { name: "location", label: "Ubicación" },
                { name: "website", label: "Sitio web" },
                { name: "phone", label: "Teléfono" },
                { name: "email", label: "Email" },
                { name: "logo", label: "URL logo" },
                { name: "featured", label: "Destacar en home", type: "checkbox", placeholder: "Destacado" },
            ]}
            defaultValues={{
                name: "",
                category: "hotel",
                description: "",
                location: "Tarifa",
                website: "",
                phone: "",
                email: "",
                logo: "",
                featured: false,
            }}
        />
    );
}
